<template>
  <article class="layout-section -bg-shade-light">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title -no-space">{{ wp.administration.title }}</h2>
      <p v-if="wp.administration.text">
        {{ wp.administration.text }}
      </p>
    </div>

    <template v-for="group in wp.administration.groups">
      <div :key="`${group.title}-hgroup`" class="layout-section__hgroup -alt-top">
        <h3 class="layout-section__title -small -no-space">{{ group.title }}</h3>
        <p v-if="group.subtitle">{{ group.subtitle }}</p>
      </div>

      <section :key="group.title" class="card-article">
        <article v-for="entry in group.members" :key="entry.name" class="card-article__item -smaller">
          <section class="card-article__content">
            <div class="card-article__hgroup">
              <h3 class="card-article__title">{{ entry.name }}</h3>
            </div>

            <p>{{ entry.text }}</p>
          </section>
        </article>
      </section>
    </template>
  </article>
</template>

<script>
export default {
  name: 'AboutCommitteesIndexMore',
  inject: ['wp']
}
</script>
